// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#recommendations[data-v-30ba6341] {
	padding: 28px 30px 0 50px;
	margin-bottom: 20px;
	display: flex;
	height: 86px;
	overflow: hidden;
	flex-wrap: wrap;
	min-width: 0;
}
.recommendation-item[data-v-30ba6341] {
	display: flex;
	align-items: center;
	flex-grow: 1;
	min-width: 250px;
}

/* show 2 per line for screen sizes smaller that 1200px */
@media only screen and (max-width: 1200px) {
#recommendations[data-v-30ba6341] {
		height: initial;
		max-height: 189px;
}
.recommendation-item[data-v-30ba6341] {
		flex-basis: 50%;
		max-width: calc(50% - 15px);
}
}

/*  GO FULL WIDTH BELOW 480 PIXELS */
@media only screen and (max-width: 480px) {
.recommendation-item[data-v-30ba6341] {
		flex-basis: 100%;
		min-width: 100%;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/FilesRecommendations.vue"],"names":[],"mappings":";AAmDA;CACA,yBAAA;CACA,mBAAA;CACA,aAAA;CACA,YAAA;CACA,gBAAA;CACA,eAAA;CACA,YAAA;AACA;AAEA;CACA,aAAA;CACA,mBAAA;CACA,YAAA;CACA,gBAAA;AACA;;AAEA,yDAAA;AACA;AACA;EACA,eAAA;EACA,iBAAA;AACA;AACA;EACA,eAAA;EACA,2BAAA;AACA;AACA;;AAEA,oCAAA;AACA;AACA;EACA,gBAAA;EACA,eAAA;AACA;AACA","sourcesContent":["<!--\n  - SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n  - SPDX-License-Identifier: AGPL-3.0-or-later\n-->\n\n<template>\n\t<div v-if=\"!loading && enabled\">\n\t\t<ul v-if=\"recommendedFiles.length > 0\"\n\t\t\tid=\"recommendations\"\n\t\t\tclass=\"group\">\n\t\t\t<li v-for=\"file in recommendedFiles\"\n\t\t\t\t:key=\"file.id\"\n\t\t\t\tclass=\"recommendation-item\">\n\t\t\t\t<RecommendedFile :id=\"file.id\"\n\t\t\t\t\t:extension=\"file.extension\"\n\t\t\t\t\t:mime-type=\"file.mimeType\"\n\t\t\t\t\t:name=\"file.name\"\n\t\t\t\t\t:directory=\"file.directory\"\n\t\t\t\t\t:reason=\"file.reason\"\n\t\t\t\t\t:has-preview=\"file.hasPreview\"\n\t\t\t\t\t:timestamp=\"file.timestamp\" />\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</template>\n\n<script>\nimport { translate as t } from '@nextcloud/l10n'\nimport RecommendedFile from './RecommendedFile.vue'\n\nexport default {\n\tname: 'FilesRecommendations',\n\tcomponents: { RecommendedFile },\n\tcomputed: {\n\t\tenabled() {\n\t\t\treturn this.$store.state.enabled\n\t\t},\n\t\tloading() {\n\t\t\treturn this.$store.state.loading\n\t\t},\n\t\trecommendedFiles() {\n\t\t\treturn this.$store.state.recommendedFiles\n\t\t},\n\t},\n\tmethods: {\n\t\tt,\n\t},\n}\n</script>\n\n<style scoped>\n#recommendations {\n\tpadding: 28px 30px 0 50px;\n\tmargin-bottom: 20px;\n\tdisplay: flex;\n\theight: 86px;\n\toverflow: hidden;\n\tflex-wrap: wrap;\n\tmin-width: 0;\n}\n\n.recommendation-item {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-grow: 1;\n\tmin-width: 250px;\n}\n\n/* show 2 per line for screen sizes smaller that 1200px */\n@media only screen and (max-width: 1200px) {\n\t#recommendations {\n\t\theight: initial;\n\t\tmax-height: 189px;\n\t}\n\t.recommendation-item {\n\t\tflex-basis: 50%;\n\t\tmax-width: calc(50% - 15px);\n\t}\n}\n\n/*  GO FULL WIDTH BELOW 480 PIXELS */\n@media only screen and (max-width: 480px) {\n\t.recommendation-item {\n\t\tflex-basis: 100%;\n\t\tmin-width: 100%;\n\t}\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
